export default __webpack_public_path__ + "static/media/sol.dca94f09.png";